<template>
  <div class="row">
    <div class="col-md-12">
      <table
        id="table-withdrawals"
        class="table table-hover table-center responsive w-100 mb-0"
      >
        <thead>
          <tr>
            <th>Método de retiro</th>
            <th>Tipo de Comisión</th>
            <th>Monto</th>
            <th class="no-sort"></th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</template>

<script>
import global from "@/helpers/global";
import table from "@/helpers/table";

export default {
  data() {
    return {
      withdrawal_methods: [],
      dataTable: null,
      tableFields: ["name", "system_commission.commission_type.display_name", "system_commission.value"],
      errors: [],
    };
  },
  mixins: [global, table],
  beforeMount() {},
  mounted() {
    this.dataTable = this.initializeTable("#table-withdrawals");

    axios
      .get(process.env.VUE_APP_API_URL + "/api/v1/withdrawal-way/all-active")
      .then((response) => {
        this.withdrawal_methods = response.data.withdrawal_ways;
      })
      .catch((error) => {
        this.errors = [];
        this.errors = error.response.data.errors ?? [];
        //console.log(error.response.data.message);
      })
      .finally(() => {
        this.generateTableWithData(this.withdrawal_methods, this.tableFields);

        //this.renderTable();

        console.log("Component mounted.");
      });

      var _self = this;

      $('a[data-toggle="tab"][href="#withdrawal"]').on("shown.bs.tab", function() {
      _self.renderTable();
    });
  },
  methods: {
    tableActions: function(id) {
      let actions = '<div class="table-action">';

      actions +=
        `<a href="` +
        this.$router.resolve({
          name: "commissions-withdrawal",
          params: { id: id },
        }).href +
        `" class="btn btn-sm bg-warning-light">
                        <i class="far fa-edit"></i> Editar
                      </a>`;

      actions += "</div>";

      return actions;
    },
  },
};
</script>
